const semanticClassNames = {
    container: 'dropzone__container',
    containerDragActive: 'dropzone__container--drag-active',
};
export default semanticClassNames;
//# sourceMappingURL=Dropzone.semanticClassNames.js.map